import { useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import { Box } from "@mui/material";
import './sidebar.css';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../../dto/UserInfo';
import { useAgente } from '../../views/hooks/agente';
import logoOdin from '../../assets/logoodinbranco.png'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from '@mui/material';

function SideBar(props: { navigateOnPages: any }) {
    const navigate = useNavigate();

    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);
    const REACT_APP_ADM_SUP = process.env.REACT_APP_ADM_SUP;
    const REACT_APP_ADM_MOBILE = process.env.REACT_APP_ADM_MOBILE;
    const { modoBloqueado } = useAgente();

    const [openLogout, setOpenLogout] = useState(false);
    const handleOpenLogout = () => setOpenLogout(true);

    const handleCloseLogout = () => setOpenLogout(false);

    useEffect(() => {
    }, [modoBloqueado])

    useEffect(() => {
    }, [userInfo])

    console.log("Dados do localStorage HEADER:", userInfo);

    function updatePage(page: string) {
        navigate("/mvp", {
            state: {
                propsPage: page
            }
        })
    }

    async function logOff() {
        await localStorage.removeItem('stbs');
        navigate("/");
    }

    function CriaItemMenu(pPage: any, IconComponent: any, pLabel: any) {
        return (
            <ListItem disablePadding key={pPage}>
                <ListItemButton
                    onClick={() => updatePage(pPage)}
                    disabled={userInfo.email === REACT_APP_ADM_SUP || modoBloqueado}
                >
                    <ListItemIcon>
                        <IconComponent />
                    </ListItemIcon>

                    <ListItemText primary={pLabel} />
                </ListItemButton>
            </ListItem>
        );
    }

    return (
        <>
            <div className='sidebar' >
                <div className="sidebar-logo">
                    <img
                        src={logoOdin}
                        alt="ODIN"
                        className="sidebar-logo-image"
                    />
                </div>

                <List sx={{ flexGrow: 1 }}>
                    {CriaItemMenu('indicadoresGraficos', HomeIcon, 'Início')}
                    {userInfo?.email === REACT_APP_ADM_MOBILE ? (
                        <>
                            {CriaItemMenu('empresas', BusinessIcon, 'Empresa')}
                            {CriaItemMenu('usuarios', PersonIcon, 'Usuários')}
                            
                        </>
                    ) : (
                        <>
                            {CriaItemMenu('pedido', ReceiptLongIcon, 'Pedido')}
                            {CriaItemMenu('agente', GroupIcon, 'Agente')}
                            
                        </>
                    )}

                </List>
                <Box
                    sx={{
                        marginTop: 'auto',
                        padding: '14px'
                    }}
                >
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={handleOpenLogout}
                            sx={{
                                borderRadius: '14px',
                                padding: '12px 14px',
                                transition: 'all .2s ease',
                                '&:hover': {
                                    background: 'rgba(239, 68, 68, 0.08)'
                                }
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 38,
                                    color: '#F87171'
                                }}
                            >
                                <LogoutOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Sair"
                                sx={{
                                    '& .MuiTypography-root': {
                                        color: '#FCA5A5',
                                        fontWeight: 600
                                    }
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                </Box>
            </div>

            <Dialog
                open={openLogout}
                onClose={handleCloseLogout}
                PaperProps={{
                    sx: {
                        borderRadius: '24px',
                        padding: '10px',
                        border: '1px solid #E2E8F0',
                        width: '100%',
                        maxWidth: '420px',
                        background: '#FFFFFF',
                        boxShadow: '0 20px 40px rgba(15,23,42,0.18)'
                    }
                }}
            >
                <Box
                    sx={{
                        width: 74,
                        height: 74,
                        borderRadius: '50%',
                        background: '#FEE2E2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '20px auto 10px auto'
                    }}
                >
                    <LogoutOutlinedIcon
                        sx={{
                            fontSize: 34,
                            color: '#EF4444'
                        }}
                    />
                </Box>
                <DialogTitle
                    sx={{
                        textAlign: 'center',
                        fontWeight: 800,
                        fontSize: '22px',
                        color: '#0F172A',
                        paddingBottom: '6px'
                    }}
                >
                    Encerrar sessão
                </DialogTitle>

                <DialogContent>
                    <DialogContentText
                        sx={{
                            textAlign: 'center',
                            color: '#64748B',
                            fontSize: '15px',
                            lineHeight: 1.6
                        }}
                    >
                        Deseja realmente sair do sistema?
                    </DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{
                        padding: '20px',
                        gap: 1
                    }}
                >
                    <Button
                        fullWidth
                        onClick={handleCloseLogout}
                        sx={{
                            borderRadius: '12px',
                            padding: '12px',
                            color: '#64748B',
                            background: '#F1F5F9',
                            fontWeight: 600,
                            '&:hover': {
                                background: '#E2E8F0'
                            }
                        }}
                    >
                        Cancelar
                    </Button>

                    <Button
                        fullWidth
                        variant="contained"
                        onClick={logOff}
                        sx={{
                            borderRadius: '12px',
                            padding: '12px',
                            background: '#EF4444',
                            fontWeight: 700,
                            boxShadow: 'none',
                            '&:hover': {
                                background: '#DC2626',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        Sair
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}



export default SideBar;
